module.exports = __webpack_public_path__ + "img/Lorinthe-Logo-white.a7c5725d.svg";